module.exports = __webpack_public_path__ + "assets/img/uncertificate.b712e871.svg";